var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinNofill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.201 17.954l4.53-4.975 1.92 1.8-5.31 4.244a.845.845 0 01-.54.177.815.815 0 01-.726-.441.722.722 0 01.113-.805H3.2zm3.914-9.899a.859.859 0 00-.787.495.766.766 0 00.182.872l6.934 6.5a.899.899 0 00.93.17.804.804 0 00.529-.738v-3.248l3.017-2.828.54.506c.228.213.545.32.865.293.32-.028.61-.188.791-.437a1.042 1.042 0 00-.162-1.317l-5.321-5a1.171 1.171 0 00-1.41-.157c-.266.17-.436.442-.466.742-.03.3.085.597.312.81l.54.507-3.028 2.83H7.115z",
    fillRule: "nonzero",
    fill: "none"
  })));
}
export default SvgPinNofill;